<template>
  <div class="mdsList-box">
    <!-- MDS饰品列表 -->

    <!-- 搜索 -->
    <el-row style="margin-bottom: 20px">
      <el-select
        style="width: 150px; margin-right: 20px"
        size="small"
        v-model="query.prizeType"
        placeholder="奖品分类"
        @change="getData()"
      >
        <el-option :value="1" label="csgo"></el-option>
      </el-select>
      <el-input
        style="width: 200px; margin-right: 20px"
        size="small"
        placeholder="商品名称搜索"
        v-model="query.keyword"
      ></el-input>
      <!-- <el-select
        style="width: 120px; margin-right: 20px"
        v-model="query.appearanceValue"
        placeholder="外观"
        size="small"
      >
        <el-option :value="undefined">不限</el-option>
        <el-option
          v-for="item in staticData.appearance"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select> -->
      <el-button
        style="margin-right: 20px"
        size="small"
        type="primary"
        @click="getData()"
        >搜索</el-button
      >
      <!-- <span class="pull-right">MDS余额: {{ 123456 }}</span> -->
    </el-row>
    <!-- 列表 -->
    <div class="prize-list-wrap" v-loading="loadingMdsPrize">
      <ul class="prize-list" v-if="mdsPrizeList && mdsPrizeList.length > 0">
        <li class="prize-item" v-for="item in mdsPrizeList">
          <i
            class="buyIcon el-icon-view"
            title="查看在售列表"
            @click="showmdsSell(item)"
          ></i>
          <p>
            <span>{{ item.name }}</span>
          </p>
          <p>
            <span>{{ item.market_hash_name }}</span>
          </p>
          <p class="price-box">
            <span class="price">{{ item.price }}</span>
          </p>
        </li>
      </ul>
      <p
        class="null_tips"
        style="text-align: center; line-height: 100px"
        v-else
      >
        暂无数据
      </p>
    </div>


    <!--MDS商品在售列表-->
    <el-dialog
        class="dialog-box"
        :visible.sync="mdsSellProductVisible"
        title="MDS商品在售列表"
        :close-on-click-modal="false"
        width="1000px"
        @close="closeMdsSellDialog"
        append-to-body
    >
      <div class="prize-list-wrap" v-loading="loadingMdsSellProduct">
        <ul
            class="prize-list"
            v-if="mdsSellProductList && mdsSellProductList.length > 0"
        >
          <li
              class="prize-item"
              v-for="sellerInfo in mdsSellProductList"
              :key="sellerInfo.id"
              style="width: 140px"
          >
            <div class="buyIcon">
              <i
                  v-if="!buyLock || buyGoodsId != sellerInfo.item_id"
                  class="el-icon-wallet"
                  title="购买物品"
                  @click="buyMds(sellerInfo)"
              ></i>
              <i v-else class="el-icon-loading" title="正在请求中..."></i>
            </div>
            <p>
              <span
              >发货类型:{{
                  sellerInfo.send_way === 1 ? "自动发货" : "手动发货"
                }}</span
              >
            </p>
            <p class="price-box" style="font-size: 13px">
              <span>{{ sellerInfo.price }}元</span>
            </p>
          </li>
        </ul>
        <p
            class="null_tips"
            style="text-align: center; line-height: 100px"
            v-else
        >
          暂无数据
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, { patchData, server, postApiData, getApiData } from '@/http'
// import appearance from '@/assets/js/appearance'
// import mallUnique from '@/assets/js/mallUnique'
// import mallQuality from '@/assets/js/mallQuality'
// import mallClassification from '@/assets/js/mallClassification'

export default {
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      mdsSellProductVisible: false, //MDS在售列表弹窗显示标志
      loading: false, //加载动画
      loadingMdsPrize: false, //mds列表加载动画
      loadingMdsSellProduct: false, //mds在售列表加载动画
      buttonLoading: false,//按钮加载动画
      buyLock: false,//防止购买重复点击锁
      buyGoodsId: undefined,//当前被购买物品的id
      query: {
        page: 1,//页数
        prizeType: 1,//奖品分类 1是csgo 5是dota2 ,默认是1
        keyword: undefined, //物品名称
        // appearanceValue: undefined, //外观
      },
      staticData: {//引入外部的js静态数据
        // appearance: appearance,//物品外观/磨损度
        // mallUnique: mallUnique,//商城物品暗金
        // mallQuality: mallQuality,//商城物品品质
        // mallClassification: mallClassification,//商城物品种类
      },
      mdsPrizeList: undefined,//MDS物品列表,
      mdsSellProductList: undefined,//MDS在售物品列表
      template_id: undefined,
    }
  },
  computed: {
    ...mapState({
      boxCategories: (state) => state.data.boxCategories, //箱子分类数据
    }),
    infos: {
      get() {
        //拿到要查询的物品名字
        return this.value
      },
      set() { }
    }
  },
  watch: {
    infos: {
      // 监听传来的订单数据
      immediate: true, //监听首次
      handler: function (val) {
        //执行代码
        if (!val) {
          //不是购买物品而是选择物品时，不会传参进来，就直接查数据
          this.getData()//查询数据
        } else {
          this.query.keyword = val.shop_prize.name
          this.getData()//查询数据
        }
      }
    }
  },
  created() {
  },
  mounted() {},
  methods: {
    getData() {
      //获取mds物品列表
      this.loadingMdsPrize = true
      let params = {
        keyword: this.query.keyword,
      }
      getApiData('mds/search', params).then(res => {
        this.loadingMdsPrize = false;
        if (res.code == 0) {
          this.mdsPrizeList = res.data;
          this.loadingMdsPrize = false;
        } else {
          this.mdsPrizeList = undefined;
        }
      }).finally(() => {
        this.loadingMdsPrize = false;
      })
    },
    showmdsSell(itemInfo) {
      this.template_id = itemInfo.template_id;
      //打开MDS在售列表弹窗
      this.mdsSellProductVisible = true;
      this.getMdsSellProduct(itemInfo);
    },
    getMdsSellProduct(infos) {
      this.mdsSellProductList = undefined
      //获取MDS在售列表数据
      this.loadingMdsSellProduct = true
      let params = {template_id: infos.template_id};
      getApiData('mds/sell_product', params)
          .then(res => {
            if (res.code == 0) {
              this.mdsSellProductList = res.data
              this.loadingMdsSellProduct = false
            } else {
              this.mdsSellProductList = undefined;
            }
          })
          .finally(() => {
            this.loadingMdsSellProduct = false
          })
    },
    buyMds(info) {
      //购买MDS商品
      if (this.buyLock) {
        //防止重复点击的锁
        this.$message.error("请求正在进行中，请勿重复点击")
        return
      }
      this.buyLock = true//加锁
      this.buyGoodsId = this.item_id;
      let params = {
        template_id: this.template_id,
        item_id: info.item_id,
        price: info.price,
        keyword: this.query.keyword,
      }
      postApiData('mds/buy/' + this.infos.id, params)
        .then(res => {
          this.$message.success('购买成功')
          this.closeMdsSellDialog() //关闭mds在售列表弹窗
          this.closeThirdDialig()//关闭第三方物品弹窗
          this.$emit("refresh")//刷新列表
          this.buyLock = false//解锁
        }).catch(error => {
          this.buyLock = false//解锁
        })
    },
    closeMdsSellDialog() {
      //关闭MDS商品在售列表
      this.mdsSellProductVisible = false
    },
    closeThirdDialig() {
      //关闭第三方物品弹窗
      this.$emit("close")
    },
  }

}

</script>
<style lang="less" scoped>
.mdsList-box {
}
</style>
